import React from "react";
import "../styles/select.scss";
// import PrimaryTheme from '../Themes/Primary';

export default function Select(props: SelectProps) {
  // const [option, setOption] = React.useState(props.active);

  // const toggleClass = () => {
  //   const ul = document.querySelector(`.${props.firstUL}`);
  //   ul?.parentElement?.classList.toggle('active');
  // }

  // const selectElement = (e: any, value: any) => {
  //   setOption(value)
  //   // $(`.${props.firstUL}`).removeClass("active");
  //   const ul = document.querySelector(`.${props.firstUL}`);
  //   ul?.parentElement?.classList.remove('active');
  // }

  return (
    <div className="align-items-center wrapper mr-2">
      {/* <div className="select_wrap">
        <ul className={"default_option m-0 " + props.firstUL} onClick={toggleClass}>
          <li>
            <div className="option text-center mr-3">
              <span style={{
                fontSize: PrimaryTheme.fontSizes?.small,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{option}</span>
            </div>
          </li>
        </ul>
        <ul className="select_ul bg-light">
          {props.list && props.list.map((item: string, index: number) =>

            <li key={index} onClick={e => selectElement(e, `${item}`)}>
              <div className="option">
                <span style={{
                  fontSize: PrimaryTheme.fontSizes?.small,
                  fontFamily: PrimaryTheme.fonts?.RegularFont
                }}>{item}</span>
              </div>
            </li>
          )}
        </ul>
      </div> */}
      {props.specialActive ? (
        <select
          name="menu"
          className="bg-warning"
          id={props.id}
          onChange={props.onChange}
          style={{
            borderRadius: 4,
            fontSize: 14,
            padding: "3px 8px",
          }}
        >
          <option value="4">With POS</option>
          <option value="1">Total</option>
          <option value="2">Active</option>
          <option value="3">Inactive</option>
        </select>
      ) : (
        <select
          name="menu"
          className="bg-warning"
          id={props.id}
          onChange={props.onChange}
          style={{
            borderRadius: 4,
            fontSize: 14,
            padding: "3px 8px",
          }}
        >
          <option value="1">Day</option>
          <option value="2">Week</option>
          <option value="3">Month</option>
        </select>
      )}
    </div>
  );
}

interface SelectProps {
  active?: "Day" | "Week" | "Month" | "Value" | "Volume" | "Both";

  list?: Array<any>;
  firstUL?: string;
  secondUL?: string;
  id?: any;
  onChange?: any;
  value?: any;
  specialActive?: "Active Agent" | "Total Agent" | "Agent With Pos";
}
